import { render } from "./HuWaiPage.vue?vue&type=template&id=9f836cee&scoped=true"
import script from "./HuWaiPage.vue?vue&type=script&lang=js"
export * from "./HuWaiPage.vue?vue&type=script&lang=js"

import "./HuWaiPage.vue?vue&type=style&index=0&id=9f836cee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f836cee"]])

export default __exports__